import { useState } from "react";
import cn from "classnames";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { authStore } from "entities/Auth";
import { useAppSelector } from "shared/lib/redux";
import { Nullable } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";
import { AlertIcon1 } from "shared/ui/Icons";
import { ChangeShippingLineModal } from "./ChangeShippingLineModal";
import styles from "./ChangeShippingLine.module.scss";

import { useChangeShippingLineSearchQuery } from "../model/useChangeShippingLineSearchQuery";

type ChangeShippingLineProps = {
  className?: string;
  openedCard: Nullable<ShipmentModel>;
  setOpenedCardAction: (card: ShipmentModel | null) => {
    type: string;
    payload: ShipmentModel | null;
  };
  updateOpenCardAction: (card: ShipmentModel) => {
    type: string;
    payload: ShipmentModel;
  };
};

export const ChangeShippingLine: RFC<ChangeShippingLineProps> = ({
  className,
  openedCard,
  setOpenedCardAction,
  updateOpenCardAction,
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [isShippingLineError, setIsShippingLineError] = useState(false);
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);

  const changeShippingLineSearchMeta = useChangeShippingLineSearchQuery(isAuthenticated);

  const closeModal = () => {
    if (changeShippingLineSearchMeta.isSearchLoading || changeShippingLineSearchMeta.isSearchFetching) {
      return;
    }
    setIsShippingLineError(false);
    setShowModal(false);
    changeShippingLineSearchMeta.resetSearchQuery();
  };

  return (
    <>
      <div className={cn(styles["change-shipping-line"], className)}>
        <AlertIcon1 className={styles.icon} />
        <span className={styles.text}>{t("Wrong shipping line?")}</span>
        <button
          type="button"
          className={styles.button}
          onClick={() => setShowModal(true)}
          data-test-id={`openedCard-action-changeSealine-${openedCard?.reference}`}
        >
          {t("Change")}
        </button>
      </div>

      {showModal && (
        <ChangeShippingLineModal
          closeModal={closeModal}
          isShippingLineError={isShippingLineError}
          setIsShippingLineError={setIsShippingLineError}
          openedCard={openedCard}
          setOpenedCardAction={setOpenedCardAction}
          updateOpenCardAction={updateOpenCardAction}
        />
      )}
    </>
  );
};
